<template>
<div>
      <div v-if="$route.path.indexOf('_editor') === -1">
      <el-row :gutter="20">

        <el-col :md="8" :lg="5">
          <el-input placeholder="活动名" v-model="params.name" clearable><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
        </el-col>
        <el-col :md="8" :lg="5">
          <el-input placeholder="创建人手机号" v-model="params.mobile" clearable><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
        </el-col>
        <el-col :md="8" :lg="5">
          <el-input placeholder="主办单位" v-model="params.organizer" clearable><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
        </el-col>
        <el-col :md="8" >
          <el-select v-model="category_id" clearable placeholder="请选择活动主题" @change="search">
            <el-option v-for="item in category" :key="item.id" :label="item.category_name" :value="item.id"> </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="20">  
        <el-col :md="9" :lg="9">
          <el-date-picker v-model="date_time" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"  @change="dateChange" format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" size="">
          </el-date-picker>
          <el-button-group>
            <el-button type="primary"  @click="handleExport">导出数据</el-button>
            <el-button type="primary"  @click="handleAdd">添加活动</el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <el-row>
      </el-row>
      <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="活动列表" name="admin"></el-tab-pane>
      <el-table :data="list" :height="wheight-160" v-loading="loading">
        <el-table-column prop="id" label="id"></el-table-column>
        <el-table-column prop="name" label="活动名"></el-table-column>
        <el-table-column prop="organizer" label="主办单位"></el-table-column>
        <el-table-column prop="address" label="活动地址"></el-table-column>
        <el-table-column prop="banner" label="图片">
          <template slot-scope="scope">
            <el-popover
                    placement="right"
                    width="240"
                    trigger="hover" >
              <img  :src="wximageurl + scope.row.banner" style="width:100%;">
              <el-button type="text" slot="reference" ><img width="75px" height="70px" :src="wximageurl + scope.row.banner" ></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="status_flag" label="是否发布">
          <template slot-scope="scope">
            <el-tag
                    :type="scope.row.status_flag == 0 ? 'info' : 'success'"
                    disable-transitions>{{scope.row.status_flag == 0 ?'未发布' :'已发布'}}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="date_time" label="活动时间">
          <template slot-scope="scope">
            <span>{{scope.row.date_time | datetime('yyyy-MM-dd hh:mm:ss')}}

            </span><br>
            <span>{{scope.row.active_time | datetime('yyyy-MM-dd  hh:mm:ss')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="deadline_time" label="报名截止日期">
          <template slot-scope="scope">
            <span>{{scope.row.deadline_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="share_img" label="活动分享码">
          <template slot-scope="scope">
            <el-popover
                    placement="right"
                    width="240"
                    trigger="hover" >
              <img  :src="wximageurl + scope.row.share_img" style="width:100%;">
              <el-button type="text" slot="reference"><img width="70px" :src="wximageurl + scope.row.share_img" ></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="to_store_img" label="活动签到码">
          <template slot-scope="scope">
            <el-popover
                    placement="right"
                    width="240"
                    trigger="hover" >
              <img  :src="wximageurl + scope.row.to_store_img" style="width:100%;">
              <el-button type="text" slot="reference"><img width="70px" :src="wximageurl + scope.row.to_store_img" ></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="max_num" label="统计">
          <template slot-scope="scope">
            <span>活动上限:{{scope.row.max_num}} 人</span> <br>
            <span>报名人数:{{scope.row.sign_in_num}}人</span><br>
            <span>签到人数:{{scope.row.to_store_num}}人</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="operating-icons">
              <!-- <i class="iconfont icon-edit1" @click="handleEditDistribution(scope.row)">编辑活动</i><br> --> 
              <!-- <el-button type="primary" size="mini" @click="handleCopyDistribution(scope.row)">复制活动</el-button> -->
              <el-button v-if="scope.row.status_flag == 0" type="primary" size="mini" @click="changeStatus(scope.row,1)">设置发布</el-button><br>
              <el-button v-if="scope.row.status_flag == 1" type="primary" size="mini" @click="changeStatus(scope.row,2)">取消发布</el-button>
              <el-button v-if="scope.row.status_flag == 0" type="primary" size="mini" @click="handleEditDistribution(scope.row)">编辑活动</el-button><br>
              <el-button v-if="scope.row.status_flag == 1" type="primary" size="mini" @click="handleEditDistribution(scope.row)">查看活动</el-button><br>
              <el-button type="primary" size="mini" @click="handleLog(scope.row)">报名信息</el-button><br>
              <el-button type="danger" size="mini" @click="deleteLog(scope.row)">删除活动</el-button><br>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="content-padded content-center">
        <el-pagination background
                       layout="prev, pager, next, total"
                       @current-change="handleCurrentChange"
                       :current-page.sync="params.page"
                       :total="total_count" :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-tabs>
      </div>
      <router-view></router-view>
</div>
</template>
<script>
    import { mapGetters } from 'vuex'
  import {delDistributorLog,editDistributorAlterAdRelDis,exportDistributorActivityDetail,getDistributorselfActivity,getDistributorActivityCategoryList,changeDistributorselfStatue} from '../../../../api/marketing'

    import imgPicker from '@/components/imageselect'
    export default {

        components: {
            imgPicker,
        },
        data () {
            return {
                category_id:'',
                clickable:false,
                dialog: false,
                distributor_dialog:false,
                relDistributors:[],
                DistributorVisible: false,
                DistributorStatus: false,
                isValid: true,
                activeName: 'admin',
                list: [],
                total_count: 0,
                loading: false,
                date_time:'',
                params: {
                    page: 1,
                    pageSize: 20,
                    name:'',
                    organizer:'',
                    mobile:'',
                    start:'',
                    end:'',
                    category_id:''
                },
                category:[],
                DistributorName:'',
                mode: 'richText',
                picsDialog: false,
                imgDialog: false,
                isGetImage: false,
                imgIndex: 0,
                cardList: [],
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            handleClose(index) {
                this.relDistributors.splice(index, 1);
                this.distributor_from.distributor_ids.splice(index, 1);
            },
            // 获取分类
            getCategoryList(){
                this.getDistributorActivityCategoryList().then(res => {
                    this.category = res.data.data.list
                })
            },
            DistributorChooseAction (data) {
                this.DistributorVisible = false
                this.DistributorStatus = false
                if (data === null || data.length <= 0) return
                this.relDistributors = data
                this.distributor_from.distributor_list = data
            },
            closeDialogAction () {
                this.DistributorStatus = false
                this.DistributorVisible = false
            },
            handleAdd () {
                this.$router.push({path: this.matchHidePage('editor')})
            },
            addDistributoreAction() {
                this.DistributorVisible = true
                this.DistributorStatus = true
            },
            handleEditDistribution(row)
            { 
              // if(row.status_flag == '1'){
              //   this.$message({ type: 'error', message: '已发布不可编辑，请关闭发布再编辑' })
              //   return;
              // }
                this.$router.push({path:'/store/storemanager/distributor_selfActivity/distributor_selfActivity_editor/'+row.id})
            },
            deleteLog (row) {
              // let data = {
              //   activity_id:row.id,
              // }
              console.log(row.id)
              this.$confirm('此操作将永久删除，如需恢复，请重新发布。', '删除提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                delDistributorLog(row.id).then(response => {
                  console.log(response.data,'222222222111111111')
                  if (response.data.data.status == 1) {
                    console.log(response,'22222222222')
                    this.$message({
                      type: 'success',
                      message: '删除成功'
                    });
                    this.params.page = 1
                    this.getList()
                  } else {
                    this.$message({type: 'error', message: response.data.data.msg})
                  }
                })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                })
              })
            },
            handleCopyDistribution(row){
                this.$router.push({path:'/store/storemanager/distributor_selfActivity/distributor_selfActivity_editor/?copyid='+row.id})
            },
            handleLog(row){
               this.$router.push({path:'/store/storemanager/distributor_selfActivity_log',query:{activity_id:row.id}})
            },
            handleDistributionSave(){
                editDistributorAlterAdRelDis(this.distributor_from).then(res => {
                    this.distributor_from = {
                        id:'',
                        distributor_ids:[],
                        image:'',
                        ad_desc:'',
                        distributor_list:[],
                    }
                    this.distributor_dialog = false
                    this.getList()
                    this.clickable = false
                    this.DistributorVisible = false
                    this.DistributorStatus = false
                    this.relDistributors = []

                    this.$message({ type: 'success', message: '操作成功' })
                })
            },
            // 修改发布状态
            changeStatus(row,status)
            {
              let status_var = '确认发布, 是否继续?'
              if(status == '2'){
                status_var = '确认取消发布, 是否继续?'
              }
              this.$confirm(status_var, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                changeDistributorselfStatue({id:row.id,status_flag:status}).then(response=>{
                let status = response.data.data.status
                var messInfo = status ? '操作成功' : '操作失败';
                var typeMes  = status ? 'success' : 'error';
                this.$message({
                  type: typeMes,
                  message: messInfo
                });
                this.getList()
                })
                
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
            },
            handleCurrentChange (val) {
                this.currentPage = val
                this.loading = false
                this.getList()
            },
            numberSearch () {
                this.params.page = 1
                this.getList()
            },
            search () {
                this.params.page = 1
                this.params.category_id = this.category_id
                this.loading = false
                this.getList()
            },
            dateChange (val) {
                if (!val) {
                    return false
                }
                this.params.start = val[0]
                this.params.end = val[1]
                this.getList()
            },
            getCategoryList(){
                getDistributorActivityCategoryList().then(res=>{
                    if(res.data.data.list){
                        this.category = res.data.data.list
                    }
                })
            },
            handleExport(){
              exportDistributorActivityDetail(this.params).then(response=>{
                if(response.data) {
                        var a = document.createElement('a')
                        a.href = response.data.url
                        a.download = response.data.filename
                        a.click()
                    }
              })
            },
            getList () {
                this.loading = true
                getDistributorselfActivity(this.params).then(response => {
                    if(response.data.data.list) {
                        // console.log(response.data.data.list)
                        this.list = response.data.data.list
                        this.total_count = Number(response.data.data.total_count)

                    }
                    this.loading = false
                })
            },
            handleImgPicker () {
                this.imgDialog = true
                this.isGetImage = true
            },
            pickImg (data) {
                this.form.image = data.url
                this.imgDialog = false
            },
            closeImgDialog () {
                this.imgDialog = false
                this.isGetImage = false
            },
        },
        mounted () {
            this.getCategoryList()
            this.getList()

        },
        watch:{
            '$route':'getList'
        }
    }
</script>

<style scoped lang="scss">
  .upload-preview {
    text-align: center;
    max-width: 200px;
    border: 1px solid #ddd;
    padding: 10px;
    position: relative;
    img {
      max-width: 200px;
      margin: 0 auto;
    }
  }
  .text-ellipsis {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vue-html5-editor {
    vertical-align: top;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// list.vue?6c0f1452